import { IDynamicServiceConfig } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { IWorkbenchService } from '@src/slide/application/service/workbench-service/core/workbench-service.interface';

export const workbenchDynamicServiceConfig: IDynamicServiceConfig<IWorkbenchService> = {
    name: 'pc-workbench-service',
    loadType: 'on-demand',
    async module() {
        const MobileWorkbenchService  = (await import('@src/slide/application/service/workbench-service/core/pc')).default;
        return new MobileWorkbenchService();
    },
};
